import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityES extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Declaración de accesibilidad - CamAPS FX</title>
                    <meta name="title" content="Declaración de accesibilidad"/>
                    <meta name="description"
                          content="CamDiab se compromete a facilitar y mejorar la accesibilidad y la facilidad de uso de sus productos digitales para todas las personas, incluidas las personas co"/>
                    <meta property="og:locale" content="es"/>
                    <meta name="keywords" content="declaración de accesibilidad"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Declaración de accesibilidad</h1>
                                <h3>Versión con fecha del 11 de septiembre de 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab se compromete a facilitar y mejorar la accesibilidad y la facilidad de uso de sus productos digitales para todas las personas, incluidas las personas con discapacidad.
                                </p>
                                <h2>
                                    Estado de conformidad
                                </h2>
                                <p>
                                    CamDiab aspira a cumplir las Pautas de Accesibilidad para el Contenido Web (WCAG) versión 2.2, nivel AA (WCAG 2.2 AA). Estas pautas reconocidas a nivel mundial ayudan a que el contenido web sea más accesible para todos.
                                </p>
                                <h2>
                                    Medidas adicionales para promover la accesibilidad
                                </h2>
                                <p>
                                    CamDiab está adoptando, entre otras, las siguientes medidas adicionales para facilitar el uso de nuestro contenido digital:
                                </p>
                                <ul>
                                    <li>Proporcionar formación continua sobre accesibilidad a nuestro personal</li>
                                    <li>Utilizar métodos formales de aseguramiento de la calidad de la accesibilidad mediante evaluaciones de terceros</li>
                                    <li>Asignar objetivos y responsabilidades claros en materia de accesibilidad</li>
                                </ul>
                                <h2>
                                    Comentarios
                                </h2>
                                <p>
                                    Agradecemos los comentarios sobre cómo podemos mejorar nuestros productos digitales para los usuarios con discapacidad. Si tiene dificultades para visualizar o navegar por nuestro contenido, o si observa algún contenido, característica o funcionalidad que considere que no es plenamente accesible para las personas con discapacidad, póngase en contacto con nosotros a través de nuestro correo electrónico de asistencia: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Nos tomamos sus comentarios muy en serio y los tendremos en cuenta a la hora de evaluar formas de atender las necesidades de todos nuestros clientes y nuestras políticas generales de accesibilidad. Asimismo, aunque no controlamos el contenido proporcionado por proveedores externos, les recomendamos encarecidamente que proporcionen contenido accesible y fácil de usar.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
